import { action } from 'typesafe-actions';
import { Fund } from 'src/components/Exchange/types';
import { AutoExchange as act } from './actionTypes';
import { FundNoteAutoExchange } from 'src/settings/settings';
import { FundDirection } from './types';

//todo: rewire editor to fire this action
export const updateInput = (
  agreementID: Fund['agreementID'],
  amount: number,
  openModal,
  updateExchangeFund
) =>
  action(act.UPDATE_FUND_INPUT, {
    agreementID,
    amount,
    openModal,
    updateExchangeFund,
  });
export const landingPageInit = () => action(act.LANDING_PAGE_INIT);
export const updateFundNote = (
  note: FundNoteAutoExchange,
  agreementID: Fund['agreementID'],
  direction: FundDirection
) => action(act.UPDATE_TO_FUND_NOTE, { note }, { direction, agreementID });
